import {createSlice} from "@reduxjs/toolkit";

export const userProfileCreated = createSlice({
  name: 'userProfileCreatedData',
  initialState:
    {
      userName: '',
      userGender: '',
      userWeight: '',
    },
  reducers: {
    createUser: (state, {payload}) => {
      const {inputNameValue, dataGender, inputWeightValue} = payload;

      state.userName = inputNameValue;
      state.userGender = dataGender;
      state.userWeight = inputWeightValue;

      const userID = localStorage.getItem('userHash');
      const localData = JSON.parse(localStorage.getItem(userID)) ?? {};
      localData['userProfileData'] = state;
      localStorage.setItem(userID, JSON.stringify(localData));
    }
  },
});

export const {createUser} = userProfileCreated.actions;
export default userProfileCreated.reducer;
